<template>
  <div>
    <div class="study">
      <div class="study-play">
          <examine></examine>
      </div>
    </div>
    <test></test>
    <div class="main">
      <div class="main-play">
        <particular-year></particular-year>
      </div>
    </div>
  </div>
</template>

<script>
  import Examine from "../../common/components/examine";
  import Test from "./components/test";
  import ParticularYear from "./components/particularYear";
  // import Standard from "./components/standard";
  export default {
    name: "Examination",
    components: {ParticularYear,Test, Examine},
    data(){
      return{
      }
    },
    methods:{
      async examList(){
        const json = await this.RequestUtil.request("/front/exam");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.examDataList = json.datas.examList;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .study{
    width: 100%;
    height: 33px;
  }

  .study-play{
    width: 1320px;
    height: 33px;
    margin: 0 auto;
  }

  .main{
    width: 100%;
    height: 530px;
  }

  .main-play{
    width: 1150px;
    height: 530px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/test/examination.vue